import Api from "../../apis/api";

import mockdata from "../ModelDataPreparation/mockdata/AdStockDecaydata.json";


import globalapi from "../../apis/apifactory";
export default {
  getcurrentproject() {
    return globalapi.getselectedproject();
  },
  addParameterBySteps(varstep, varparms) {
    let varproject = this.getcurrentproject();
    let apiurl =
      "save_project_details/?project=" +
      varproject +
      "&step=" +
      varstep +
      "&" +
      varparms;

    return Api.get(apiurl);
  },
  addParameterByStepsbyurl(varparms) {
    let apiurl = "save_project_details/?";
    apiurl = apiurl + varparms;
    //alert((apiurl);
    return Api.get(apiurl);
  },
  gettheParameterByProjectStep(varstep) {
    let varproject = this.getcurrentproject();
    let apiurl = "save_project_details/?project=" + varproject + "&step=" + varstep;

    return Api.get(apiurl);
  },
  // SessionalitySetting
  getseasonalitydata() {
    let apiurl = "seasonality-data/?project=" + this.getcurrentproject() + "&step=5";

    return Api.get(apiurl);
  },
  getseasonalityplot() {
    // let apiurl = "seasonality-plots/?country=india&brand=xyz&level=national&time=date&sales_value=sales&sales_volume=volume&activity=non_clm_call,clm_call,webinar,mass_email,email_1to1,phone_call&competitor=comp1&step=1&zscore=0&bzscore=0&subzscore=0&trend=1&season=1&comp=0";
    //return Api.get(apiurl);

    let apiurl = "seasonality-plots/?project=" + this.getcurrentproject() + "&step=5";

    return Api.get(apiurl);
  },
  getseasonalitydatalog(
    varstep,
    varzscore,
    varbzscore,
    varsubzscore,
    vartrend,
    varseason,
    varcomp
  ) {
    //let apiurl = "seasonality-logs/?step=1&zscore=0&bzscore=0&subzscore=0&trend=1&season=1&comp=0"
    let apiurl = "seasonality-logs/?";

    return Api.get(apiurl, {
      params: {
        step: varstep,
        zscore: varzscore,
        bzscore: this.convertbooltoint(varbzscore),
        subzscore: this.convertbooltoint(varsubzscore),
        trend: this.convertbooltoint(vartrend),
        season: this.convertbooltoint(varseason),
        comp: this.convertbooltoint(varcomp),
      },
    });
  },
  //adstockdecay
  getdecayexpiryMockData() {
    return mockdata;
  },
  getdecayexpiry(varparmurl,
    selectapply_ads_activity,
    selectapply_ads_base,
    selected_notapply_ads_var_string
  ) {
    let newurlparms =
      "apply_ads_activity=" +
      this.convertbooltoint(selectapply_ads_activity) +
      "&apply_ads_base=" +
      this.convertbooltoint(selectapply_ads_base) +
      "&notapply_ads_var=" +
      selected_notapply_ads_var_string +
      "";
    //let apiurl ="apply_adstock_varlist/?country=india&brand=xyz&level=national&time=date&sales_value=sales&sales_volume=volume&activity=non_clm_call,clm_call,webinar,mass_email,email_1to1,phone_call&competitor=comp1&zscore=0&bzscore=0&subzscore=0&trend=1&season=1&comp=0&step=6&" +newurlparms;
    let apiurl = "apply_adstock_varlist/?" + varparmurl + "&step=6&" + newurlparms;
    //let apiurl = "apply_adstock_varlist/?";

    return Api.get(apiurl);
  },
  getapply_adstock_varlist(apply_ads_activity, apply_ads_base, varparmurl) {
    // "notapply_adstock_varlist/?country=india&brand=xyz&level=national&time=date&sales_value=sales&sales_volume=volume&activity=non_clm_call,clm_call,webinar,mass_email,email_1to1,phone_call&competitor=comp1&zscore=0&bzscore=0&subzscore=0&trend=1&season=1&comp=0&step=6&apply_ads_activity=" +
    let apiurl =
      "notapply_adstock_varlist/?" + varparmurl + "&step=6&apply_ads_activity=" +
      apply_ads_activity +
      "&apply_ads_base=" +
      apply_ads_base +
      "";
    //let apiurl = "apply_adstock_varlist/?";
    // //alert((apiurl);
    return Api.get(apiurl);
  },
  /*getadstockdecay_data(decay_expiry_ads) {
    let apiurl =
      "adstock-data/?country=india&brand=xyz&level=national&time=date&sales_value=sales&sales_volume=volume&activity=non_clm_call,clm_call,webinar,mass_email,email_1to1,phone_call&competitor=comp1&zscore=0&bzscore=0&subzscore=0&trend=1&season=1&comp=0&step=6&apply_ads_activity=1&apply_ads_base=0&notapply_ads_var=a_phone_call,a_webinar,a_mass_email,a_email_1to1&min_ads=10&max_ads=70&decay_expiry_ads=" +
      decay_expiry_ads +
      "";
    //let apiurl = "apply_adstock_varlist/?";
    
    return Api.get(apiurl);
  },*/
  getadstockdecay_datanew() {
    let apiurl = "adstock-data/?project=" + this.getcurrentproject() + "&step=6";
    //let apiurl = "apply_adstock_varlist/?";

    return Api.get(apiurl);
  },
  //end
  //newvariable reation
  newvariable_getall(projectid, stepid) {
    let querystringvar = "project=" + projectid + "&step=" + stepid;
    let apiurl = "newvariable/?" + querystringvar + "";
    //let apiurl = "apply_adstock_varlist/?";
    // //alert((apiurl);
    return Api.get(apiurl);
  },
  newvariable_getbyid(variableid) {
    let querystringvar = "id=" + variableid;
    let apiurl = "newvariable/?" + querystringvar + "";
    //let apiurl = "apply_adstock_varlist/?";

    return Api.get(apiurl);
  },
  newvariable_Addnew(projectid, stepid, varname, createdby) {
    let querystringvar =
      "project=" +
      projectid +
      "&name=" +
      varname +
      "&step=" +
      stepid +
      "&createdby=" +
      createdby +
      "";
    let apiurl = "newvariable/?" + querystringvar + "";
    //let apiurl = "apply_adstock_varlist/?";

    return Api.get(apiurl);
  },
  newvariable_update(varid, varname, Modifiedby) {
    //http://127.0.0.1:8000/newvariable/?id=4&isdisable=True&modifiedby=8

    let querystringvar =
      "id=" + varid + "&name=" + varname + "&modifiedby=" + Modifiedby + "";
    let apiurl = "newvariable/?" + querystringvar + "";
    //let apiurl = "apply_adstock_varlist/?";

    return Api.get(apiurl);
  },
  newvariable_delete(varid, Modifiedby) {
    //http://127.0.0.1:8000/newvariable/?id=4&isdisable=True&modifiedby=8

    let querystringvar =
      "id=" + varid + "&isdisable=1&modifiedby=" + Modifiedby + "";
    let apiurl = "newvariable/?" + querystringvar + "";
    //let apiurl = "apply_adstock_varlist/?";

    return Api.get(apiurl);
  },
  //end
  //newvariabledetails
  newvariableDetail_Adddetails(newvar, variable, weight, createdby) {
    //newvariable_detail/?newvar=1&variable=tv_1&weight=2&createdby=8

    let querystringvar =
      "newvar=" +
      newvar +
      "&variable=" +
      variable +
      "&weight=" +
      weight +
      "&createdby=" +
      createdby +
      "";
    let apiurl = "newvariable_detail/?" + querystringvar + "";
    //let apiurl = "apply_adstock_varlist/?";
    //
    return Api.get(apiurl);
  },
  newvariableDetail_GetAllByVarid(newvarid) {
    //newvariable_detail/?newvar=1&variable=tv_1&weight=2&createdby=8

    let querystringvar = "newvar=" + newvarid + "";
    let apiurl = "newvariable_detail/?" + querystringvar + "";
    //let apiurl = "apply_adstock_varlist/?";

    return Api.get(apiurl);
  },
  newvariableDetail_GetAllByVaridLin(newvarid) {
    //newvariable_detail/?newvar=1&variable=tv_1&weight=2&createdby=8

    let querystringvar = "newvar=" + newvarid + "";
    let apiurl = "newvariable_detail/?" + querystringvar + "";
    //let apiurl = "apply_adstock_varlist/?";
    // //alert("lin"+apiurl);
    return Api.get(apiurl);
  },
  newvariableDetail_GetbyId(detailid) {
    //newvariable_detail/?newvar=1&variable=tv_1&weight=2&createdby=8

    let querystringvar = "id=" + detailid + "";
    let apiurl = "newvariable_detail/?" + querystringvar + "";
    //let apiurl = "apply_adstock_varlist/?";

    return Api.get(apiurl);
  },
  newvariableDetail_Update(id, modifiedby, weight) {
    //newvariable_detail/?newvar=1&variable=tv_1&weight=2&createdby=8

    let querystringvar =
      "id=" + id + "&modifiedby=" + modifiedby + "&weight=" + weight + "";
    let apiurl = "newvariable_detail/?" + querystringvar + "";
    //let apiurl = "apply_adstock_varlist/?";

    return Api.get(apiurl);
  },
  newvariableDetail(id, modifiedby) {
    //newvariable_detail/?newvar=1&variable=tv_1&weight=2&createdby=8

    let querystringvar =
      "id=" + id + "&modifiedby=" + modifiedby + "&isdisable=1";
    let apiurl = "newvariable_detail/?" + querystringvar + "";
    //let apiurl = "apply_adstock_varlist/?";

    return Api.get(apiurl);
  },
  newvariableDetail_Delete(id, modifiedby, newvarid) {
    //newvariable_detail/?newvar=1&variable=tv_1&weight=2&createdby=8

    let querystringvar =
      "id=" + id + "&modifiedby=" + modifiedby + "&isdisable=1&newvar=" + newvarid;
    let apiurl = "newvariable_detail/?" + querystringvar + "";
    //let apiurl = "apply_adstock_varlist/?";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  newvariableDetail_DeleteLinearDetail(id, modifiedby, newvarid) {
    //newvariable_detail/?newvar=1&variable=tv_1&weight=2&createdby=8

    let querystringvar =
      "id=" + id + "&modifiedby=" + modifiedby + "&isdisable=1&newvar=" + newvarid;
    let apiurl = "newvariable_detail/?" + querystringvar + "";
    //let apiurl = "apply_adstock_varlist/?";

    return Api.get(apiurl);
  },
  newvar_creation_varlist() {

    let apiurl = "newvar_creation_varlist/?project=" + this.getcurrentproject() + "&step=8";
    //let apiurl = "apply_adstock_varlist/?";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  newvar_creation_varlist_new(varparms) {

    let apiurl = "newvar_creation_varlist/?step=8&" + varparms + "";
    //let apiurl = "apply_adstock_varlist/?";

    return Api.get(apiurl);
  },
  //end
  //get data for SessionalitySetting Data tab
  //http://mmmplatformapi-env.eba-dtpwwm2u.ap-south-1.elasticbeanstalk.com/newvar_data/?country=india&brand=xyz&level=national&time=date&sales_value=sales&sales_volume=volume&activity=non_clm_call,clm_call,webinar,mass_email,email_1to1,phone_call&competitor=comp1&zscore=0&bzscore=0&subzscore=0&trend=1&season=1&comp=0&step=8&project=14&apply_ads_activity=1&apply_ads_base=0&notapply_ads_var=a_phone_call,a_webinar,a_mass_email,a_email_1to1&min_ads=10&max_ads=70&decay_expiry_ads=[{%22id%22:%22a_clm_call%22,%22value%22:2},{%22id%22:%22a_non_clm_call%22,%22value%22:0}]
  newvar_data(varparms) {
    let apiurl = "newvar_data/?step=8&" + varparms + "";
    //let apiurl = "apply_adstock_varlist/?";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  //dummy variable page api data
  dummyvariables_getall() {
    //let apiurl = "get_dummy/?step=7&project=" + projectid + "";
    let apiurl = "get_dummy_data/?step=4&project=" + this.getcurrentproject() + "";
    return Api.get(apiurl);
  },
  dummyvariables_save(projectid, params) {
    let apiurl = "save_dummy/?step=7&project=" + projectid + "&param=" + params;
    //let apiurl = "apply_adstock_varlist/?";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  dummyvariables_AddNewDummyVarForUI() {

    //let apiurl = "add_dummy/?step=7&n="+noofdummyvar +"&project=" + projectid + "&" + varparms;
    let apiurl = "add_dummy_var/?step=4&project=" + this.getcurrentproject();
    //let apiurl = "apply_adstock_varlist/?";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  dummyvariables_AddNewDummyVarForUI_tbd(projectid, noofdummyvar) {
    //let apiurl = "add_dummy/?step=7&n="+noofdummyvar +"&project=" + projectid + "&" + varparms;
    let apiurl = "add_dummy/?step=7&n=" + noofdummyvar + "&project=" + projectid;
    //let apiurl = "apply_adstock_varlist/?";
    //alert((apiurl);
    return Api.get(apiurl);
  },

  //end dummy data
  //variabletransaformation
  variableTransformation_GetVarlist(varparms) {
    //let apiurl = "add_dummy/?step=7&n="+noofdummyvar +"&project=" + projectid + "&" + varparms;
    let apiurl = "transform_varlist/?step=10&" + varparms;
    //let apiurl = "apply_adstock_varlist/?";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  variableTransformation_save(projectid, varparms) {
    //let apiurl = "add_dummy/?step=7&n="+noofdummyvar +"&project=" + projectid + "&" + varparms;
    let apiurl = "save_transformations/?step=10&project=" + projectid + "&param=" + varparms;
    //let apiurl = "apply_adstock_varlist/?";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  variableTransformation_getdata(projectid, varparms) {
    //let apiurl = "add_dummy/?step=7&n="+noofdummyvar +"&project=" + projectid + "&" + varparms;
    let apiurl = "get_transform_data/?step=10&" + varparms;
    //let apiurl = "apply_adstock_varlist/?";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  //end
  //variabletransaformation-New
  api_variableTransformation_GetVarlist() {
    //let apiurl = "add_dummy/?step=7&n="+noofdummyvar +"&project=" + projectid + "&" + varparms;
    let apiurl = "get_varlist_for_transformation/?project=" + this.getcurrentproject() + "&step=5";
    //let apiurl = "apply_adstock_varlist/?";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  call_get_step5_output() {

    let apiurl = "get_step5_output/?step=5&project=" + this.getcurrentproject();
    //let apiurl = "apply_adstock_varlist/?";
    // //alert((apiurl);
    return Api.get(apiurl);
  },
  api_save_transformationvariable(varregion, variablename, functionname, paramval) {
    let apiurl = "save_var_transformations/?project=" + this.getcurrentproject() + "&region=" + varregion + "&variable=" + variablename + "&function=" + functionname + "&param=" + paramval + "";
    //let apiurl = "apply_adstock_varlist/?";
    ////alert(apiurl);
    return Api.get(apiurl);
  },
  api_save_transformationvariable_getsavedvalues() {
    let apiurl = "save_var_transformations/?project=" + this.getcurrentproject() ;
    //let apiurl = "apply_adstock_varlist/?";
    ////alert(apiurl);
    return Api.get(apiurl);
  },
  //end
  //split-variables//
  splitvar_getsplitvarlist() {

    let apiurl = "split_varlist/?step=11&project=" + this.getcurrentproject();
    //let apiurl = "apply_adstock_varlist/?";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  splitvar_get_split_varbyvarname(strvarname) {

    let apiurl = "get_split_var/?step=11&project=" + this.getcurrentproject() + "&var=" + strvarname + "";
    //let apiurl = "apply_adstock_varlist/?";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  splitvar_save_split(strvarname) {
    let varproject = this.getcurrentproject();
    let apiurl = "save_split/?project=" + varproject + "&step=11&param=" + strvarname + "";
    //let apiurl = "apply_adstock_varlist/?";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  splitvar_get_split_data() {

    let apiurl = "get_split_data/?step=11&project=" + this.getcurrentproject()
    //let apiurl = "apply_adstock_varlist/?";
    ////alert(apiurl);
    return Api.get(apiurl);
  },
  //save_split/?project=14&step=11&param=[{"variable":"a_clm_call", "split":[0,3,4,8,11,19]}]
  //end
  convertbooltoint(varbool) {
    //alert((varbool);
    //result ? 1 : 0;
    let ivalue = varbool ? 1 : 0;

    return ivalue;
  },
  convertinttoboll(varint) {
    //alert((varbool);
    //result ? 1 : 0;
    let ivalue = varint === 1 ? true : false;

    return ivalue;
  },

  async callfind_decay() {
    let apiurl = "find_decay/?project=" + this.getcurrentproject() + "&step=3";
    //let apiurl = "apply_adstock_varlist/?";
    ////alert(apiurl);
    return Api.get(apiurl);
  },
  callsave_channel_decay(varregion, varparamarray) {
    let apiurl = "save_channel_decay/?project=" + this.getcurrentproject() + "&region=" + varregion + "&param=" + varparamarray + "";
    //let apiurl = "apply_adstock_varlist/?";
    //alert(('dd' + apiurl);
    return Api.get(apiurl);
  },
  call_get_project_region_list() {

    let apiurl = "get_project_region_list/?project=" + this.getcurrentproject();
    //let apiurl = "apply_adstock_varlist/?";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  call_get_step3_output() {

    let apiurl = "get_step3_output/?step=3&project=" + this.getcurrentproject();
    //let apiurl = "apply_adstock_varlist/?";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  call_getsaved_channel_decay() {

    let apiurl = "save_channel_decay/?step=3&project=" + this.getcurrentproject();
    //let apiurl = "apply_adstock_varlist/?";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  // new for dummyvar
  call_save_dummy_var(varname, vparname, region, type) {

    let apiurl = "save_dummy_var/?project=" + this.getcurrentproject() + "&var_name=" + varname + "&param=" + vparname + "&region=" + region + "&type=" + type;
    //let apiurl = "apply_adstock_varlist/?";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  //SynegyEffectbwVariables
  call_save_newvar_getbyprojectid() {

    let apiurl = "save_newvar/?project=" + this.getcurrentproject();
    //let apiurl = "apply_adstock_varlist/?";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  call_save_newvar_AddNew(var_name, var_type) {

    let apiurl = "save_newvar/?project=" + this.getcurrentproject() + "&var_name=" + var_name + "&var_type=" + var_type + "";
    //let apiurl = "apply_adstock_varlist/?";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  call_save_newvar_edit(var_id, var_name, var_type) {

    let apiurl = "save_newvar/?project=" + this.getcurrentproject() + "&id=" + var_id + "&var_name=" + var_name + "&var_type=" + var_type + "";
    //let apiurl = "apply_adstock_varlist/?";
    //alert((apiurl);
    return Api.get(apiurl);
  },


  call_get_itemvar_type() {
    let temitemvar_type = [];
    let obj = new Object();
    obj.Name = "LinearCombination";
    obj.value = "linear_combination";
    temitemvar_type.push(obj);
    let obj1 = new Object();
    obj1.Name = "synergy";
    obj1.value = "synergy";
    temitemvar_type.push(obj1);
    //alert(('call method');
    return temitemvar_type;
    // this.itemvar_type_selected = temitemvar_type[0];

  },
  call_get_varlist_for_newvar() {

    let apiurl = "get_varlist_for_newvar/?project=" + this.getcurrentproject() + "&step=4";
    //let apiurl = "apply_adstock_varlist/?";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  call_save_newvar_detail(newvar, variable, weight, region) {
    //newvariable_detail/?newvar=1&variable=tv_1&weight=2&createdby=8

    let querystringvar =
      "newvar=" + newvar + "&variable=" + variable + "&weight=" + weight + "&region=" + region + "";
    let apiurl = "save_newvar_detail/?" + querystringvar + "";
    //let apiurl = "apply_adstock_varlist/?";
    ///alert((apiurl);
    return Api.get(apiurl);
  },
  call_save_newvar_detail_byid(newvarid) {
    //newvariable_detail/?newvar=1&variable=tv_1&weight=2&createdby=8

    let querystringvar = "newvar=" + newvarid + "";
    let apiurl = "save_newvar_detail/?" + querystringvar + "";
    //let apiurl = "apply_adstock_varlist/?";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  call_save_newvar_detail_delete(newvardetailid, newvarid, modifiedby) {
    //newvariable_detail/?newvar=1&variable=tv_1&weight=2&createdby=8
    //id=31&modifiedby=9&isdisable=1&newvar=12
    let querystringvar = "id=" + newvardetailid + "&modifiedby=" + modifiedby + "&isdisable=1&newvar=" + newvarid + "";
    let apiurl = "save_newvar_detail/?" + querystringvar + "";
    //let apiurl = "apply_adstock_varlist/?";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  call_save_newvar_delete(varid) {
    //http://127.0.0.1:8000/newvariable/?id=4&isdisable=True&modifiedby=8

    let querystringvar =
      "id=" + varid + "&isdisable=1";
    let apiurl = "save_newvar/?" + querystringvar + "";
    //let apiurl = "apply_adstock_varlist/?";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  call_getdata_fornewvarceation() {

    let apiurl = "get_step4_output/?project=" + this.getcurrentproject() + "&step=4";
    //let apiurl = "apply_adstock_varlist/?";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  //save_step3

  call_save_step3() {

    let apiurl = "save_step3/?project=" + this.getcurrentproject();
    //let apiurl = "apply_adstock_varlist/?";
    //alert(apiurl);
    return Api.get(apiurl);
  },
  call_save_step4() {

    let apiurl = "save_step4/?project=" + this.getcurrentproject();
    //let apiurl = "apply_adstock_varlist/?";
    //alert(apiurl);
    return Api.get(apiurl);
  },
  //standardization
  api_save_var_standardization(varvariable, varfunction) {

    let apiurl = "save_var_standardization/?variable=" + varvariable + "&function=" + varfunction + "&project=" + this.getcurrentproject();
    //alert((apiurl);
    return Api.get(apiurl);
  },
  api_save_var_standardization_delete(varvariable, varfunction) {

    let apiurl = "save_var_standardization/?variable=" + varvariable + "&isdisable=1&function=" + varfunction + "&project=" + this.getcurrentproject();
    //alert((apiurl);
    return Api.get(apiurl);
  },
  api_get_save_var_standardization() {

    let apiurl = "save_var_standardization/?project=" + this.getcurrentproject();
    //alert((apiurl);
    return Api.get(apiurl);
  },
  api_get_varlist_for_standardization() {

    let apiurl = "get_varlist_for_standardization/?step=5&project=" + this.getcurrentproject();
    //alert((apiurl);
    return Api.get(apiurl);
  },
  api_get_functionforstandardization() {
    let templist = [];
    let obj1 = new Object();
    obj1.id = 1;
    obj1.name = "zscore";
    obj1.value = "zscore";
    templist.push(obj1);

    let obj2 = new Object();
    obj2.id = 2;
    obj2.name = "divcm";
    obj2.value = "divcm";
    templist.push(obj2);

    let obj3 = new Object();
    obj3.id = 3;
    obj3.name = "subcm";
    obj3.value = "subcm";
    templist.push(obj3);


    let obj4 = new Object();
    obj4.id = 4;
    obj4.name = "divcmdvsubcm";
    obj4.value = "divcmdvsubcm";
    templist.push(obj4);

    return templist;
  },

  //split variable
  api_get_varlist_for_split() {
    let apiurl = "get_varlist_for_split/?step=5&project=" + this.getcurrentproject();
    //alert((apiurl);
    return Api.get(apiurl);
  },
  api_save_var_split(vvariable, vregion, vdateparam) {
    let apiurl = "save_var_split/?project=" + this.getcurrentproject() + "&variable=" + vvariable + "&region_param=" + vregion + "&date_param=" + vdateparam + "&remainder=1";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  api_update_var_split(vvariable, vregion, vdateparam, vvarname) {
    let apiurl = "save_var_split/?project=" + this.getcurrentproject() + "&variable=" + vvariable + "&region_param=" + vregion + "&date_param=" + vdateparam + "&remainder=1&var_name=" + vvarname + "";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  api_get_var_split() {
    let apiurl = "save_var_split/?project=" + this.getcurrentproject();
    //alert((apiurl);
    return Api.get(apiurl);
  },
  call_save_step5() {

    let apiurl = "save_step5/?project=" + this.getcurrentproject();
    //let apiurl = "apply_adstock_varlist/?";
    //alert(apiurl);
    return Api.get(apiurl);
  },

  callallsteps(){
    let allresult = [];
    let axiosrequestbuffer = [];
    let apiurl1 = "save_step3/?project=" + this.getcurrentproject();
    //alert((apiurl1);
    //let apiurl2 = "save_step3/?project=" + this.getcurrentproject();
    //let apiurl3 = "save_step3/?project=" + this.getcurrentproject();
    
    //Api.get(apiurl2);
    //Api.get(apiurl3);
    axiosrequestbuffer.push(Api.get(apiurl1));
    //axiosrequestbuffer.push(Api.get(apiurl2));
    //axiosrequestbuffer.push(Api.get(apiurl3));
    Promise.all(axiosrequestbuffer).then((result) => {
      //alert(JSON.stringify(result));
      allresult.push(result);
    });
   
  }

};
